import { useUserStore } from '../stores/userStore';

// Single source of truth for backend endpoints. In development the Go API
// runs on :8080; in production the Go server serves this SPA, so the API is
// same-origin.
export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV
    ? 'http://localhost:8080/api/v1'
    : `${window.location.origin}/api/v1`);

export const WS_URL: string =
  import.meta.env.VITE_WS_URL ||
  (import.meta.env.DEV
    ? 'ws://localhost:8080/ws'
    : `${window.location.origin.replace(/^http/, 'ws')}/ws`);

// Token access for non-hook code (fetch clients, websocket setup).
export function getAuthToken(): string | null {
  return useUserStore.getState().token;
}

export function authHeaders(): Record<string, string> {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
